import { Device, waitFor } from '@goodboydigital/astro';
import { Container } from 'pixi.js';

import { BillboardCar } from './BillboardCar';
import { BillboardIcon } from './BillboardIcon';
import { BillboardKeys } from './BillboardKeys';
import { BillboardPedal } from './BillboardPedal';

export class BillboardTutorialAccelerate extends Container
{
    private mobile: boolean;
    private car: BillboardCar;
    private iconForward: BillboardIcon;
    private animating = false;

    // Desktop controls
    private keys?: BillboardKeys;

    // Mobile controls
    private pedalAcc?: BillboardPedal;

    constructor()
    {
        super();

        this.mobile = Device.mobile;

        this.iconForward = new BillboardIcon('icon-double-arrow');
        this.addChild(this.iconForward);
        this.iconForward.x = -100;
        this.iconForward.y = -80;

        this.car = new BillboardCar();
        this.addChild(this.car);
        this.car.x = -110;
        this.car.y = -10;

        this.mobile ? this.setupMobile() : this.setupDesktop();
    }

    private setupDesktop(): void
    {
        this.keys = new BillboardKeys();
        this.addChild(this.keys);
        this.keys.visible = !this.mobile;
        this.keys.x = 120;
        this.keys.y = -33;
        this.keys.scale.set(0.7);
        this.keys.up.highlight();
    }

    private setupMobile(): void
    {
        this.pedalAcc = new BillboardPedal('acc');
        this.pedalAcc.x = 120;
        this.pedalAcc.y = -33;
        this.addChild(this.pedalAcc);
    }

    public updateTransform(): void
    {
        super.updateTransform();
        this.animate();
    }

    private async animate(): Promise<void>
    {
        if (this.animating) return;
        this.animating = true;

        await waitFor(200);

        // Go away
        this.keys?.up.press();
        this.pedalAcc?.press();
        this.iconForward.highlight();
        await this.car.goAwayForward();

        // Come back
        this.iconForward.normal();
        this.keys?.up.release();
        this.pedalAcc?.release();
        await this.car.comeBack();

        await waitFor(200);

        this.animating = false;
    }
}
